import { useState, useEffect, useRef } from "react";
import axios from "axios";
import useEmblaCarousel from "embla-carousel-react";
import { Reveal } from "./Reveal";
const featuredVideo = { id: "730939054", h: "a33d34eee4", title: "Silvia — All on 4 e impianti zigomatici" };
import { Quote, Star, PlayCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GOOGLE_REVIEWS_URL = "https://www.google.com/search?sca_esv=8731fb38ab1cc8da&sxsrf=APpeQnvtQh0D5ii3DEeHEuLtyh7CaXZRWQ:1787159086731&q=gruppo+implantologico+italiano&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_w705Wlp0_FAw3NFllFjPYjbsEQxdAUtn3Bfr8JeHh5QPVYYkod01D5SzXOBhPpYQ288drY%3D&uds=AJ5uw1-NaMLnLWVMl0MgDAFSAvhiA4jjNkQR9Ji4J9NQksDHeX6g1Qn9F1Kbqlr9lmY-YDGDEeVmOHG1EiPMpzCb-HIjK-6Ns7IeRxos_VHNhkeB8HpILN5LfBDfBdM0e4DKZcrC9lOr";

const items = [
  {
    text: "Sono dei professionisti nel loro campo. Provato io e mia moglie, ora mio cognato: sono speciali tutti loro.",
    name: "Renzo",
    detail: "Studio di Arese",
  },
  {
    text: "Quella emozionata ero io nel vedermi con una bocca strabiliante, e non finirò mai di ringraziarli.",
    name: "Cristina",
    detail: "Como",
  },
  {
    text: "Grazie all'équipe di implantologia: è stato fatto un capolavoro, lo confermo.",
    name: "Antonio",
    detail: "Bergamo",
  },
];

const Stars = ({ rating }) => (
  <span className="flex items-center gap-0.5" aria-label={`${rating} stelle su 5`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={16} className={n <= Math.round(rating) ? "text-[#FBBC05] fill-[#FBBC05]" : "text-[#D8DDD9]"} />
    ))}
  </span>
);

export const Testimonials = () => {
  const [google, setGoogle] = useState(null);
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "start" });
  const hovering = useRef(false);

  useEffect(() => {
    axios.get(`${API}/google-reviews`).then(({ data }) => setGoogle(data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!emblaApi) return;
    const id = setInterval(() => { if (!hovering.current) emblaApi.scrollNext(); }, 4500);
    return () => clearInterval(id);
  }, [emblaApi]);

  const reviews = google?.reviews?.length ? google.reviews : null;
  const slides = reviews ? (reviews.length < 8 ? [...reviews, ...reviews] : reviews) : null;

  return (
  <section id="recensioni" className="py-24 md:py-32 px-6 md:px-12 bg-[#DDEBF2]" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 items-center mb-16">
        <Reveal>
          <div className="relative aspect-video rounded-[28px] overflow-hidden border border-border bg-black" data-testid="testimonials-featured-video">
            <iframe
              src={`https://player.vimeo.com/video/${featuredVideo.id}?h=${featuredVideo.h}&title=0&portrait=0&byline=0&badge=0&dnt=1`}
              title={featuredVideo.title}
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              loading="lazy"
            />
          </div>
          <p className="mt-3 text-sm font-semibold text-[#5C6B61]">{featuredVideo.title}</p>
          <a
            href="#video-pazienti"
            className="mt-2 inline-flex items-center gap-2 font-bold text-[#385244] hover:text-[#C98E6E] transition-colors duration-300"
            data-testid="testimonials-video-link"
          >
            <PlayCircle size={18} /> Guarda tutte le video-testimonianze →
          </a>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#7D9285] mb-4">Esperienze dei pazienti</p>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#15201A]">
            Chi è tornato a <em className="italic text-[#385244]">sorridere</em> con i denti fissi
          </h2>
        </Reveal>
      </div>
      {slides ? (
        <Reveal>
          <div
            className="overflow-hidden"
            ref={emblaRef}
            onMouseEnter={() => { hovering.current = true; }}
            onMouseLeave={() => { hovering.current = false; }}
            data-testid="google-reviews-carousel"
          >
            <div className="flex -ml-6">
              {slides.map((r, i) => (
                <div key={`${r.id || r.author}-${i}`} className="pl-6 flex-[0_0_100%] md:flex-[0_0_50%] lg:flex-[0_0_33.333%] min-w-0">
                  <figure className="h-full bg-white rounded-[28px] p-8 border border-border flex flex-col" data-testid={`google-review-card-${i}`}>
                    <Stars rating={r.rating} />
                    <blockquote className="mt-5 text-base md:text-lg leading-relaxed text-[#15201A] flex-1 line-clamp-[9]">"{r.text}"</blockquote>
                    <figcaption className="mt-6">
                      {r.author_uri ? (
                        <a href={r.author_uri} target="_blank" rel="noopener noreferrer" className="font-bold text-[#385244] hover:underline">{r.author}</a>
                      ) : (
                        <p className="font-bold text-[#385244]">{r.author}</p>
                      )}
                      <p className="text-sm text-[#5C6B61]">
                        {r.relative_time} · da Google
                        {r.google_maps_uri && (
                          <> · <a href={r.google_maps_uri} target="_blank" rel="noopener noreferrer" className="underline">vedi su Maps</a></>
                        )}
                      </p>
                    </figcaption>
                  </figure>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-10 flex justify-center">
            <a
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 rounded-full bg-[#385244] hover:bg-[#2B4035] text-white text-base font-bold px-8 py-4 transition-colors duration-300 active:scale-95 shadow-lg shadow-[#385244]/20"
              data-testid="google-reviews-cta-btn"
            >
              <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Leggi tutte le recensioni reali su Google
            </a>
          </div>
        </Reveal>
      ) : (
      <div className="grid md:grid-cols-3 gap-6">
        {items.map((t, i) => (
              <Reveal key={t.name} delay={i * 0.12}>
                <figure className="h-full bg-white rounded-[28px] p-8 border border-border flex flex-col" data-testid={`testimonial-card-${i}`}>
                  <Quote className="text-[#C98E6E]" size={30} strokeWidth={1.5} />
                  <blockquote className="mt-5 text-base md:text-lg leading-relaxed text-[#15201A] flex-1">"{t.text}"</blockquote>
                  <figcaption className="mt-6">
                    <p className="font-bold text-[#385244]">{t.name}</p>
                    <p className="text-sm text-[#5C6B61]">{t.detail}</p>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
      </div>
      )}
      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-wrap items-center gap-4 bg-white border border-border rounded-[24px] p-6 md:p-8" data-testid="google-reviews-block">
          <svg viewBox="0 0 24 24" width="36" height="36" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <div className="flex-1 min-w-[220px]">
            <p className="font-serif-display text-xl text-[#15201A]">Le recensioni verificate sono su Google</p>
            {google?.rating ? (
              <span className="mt-1 flex items-center gap-2 text-sm text-[#5C6B61]" data-testid="google-rating-summary">
                <Stars rating={google.rating} />
                <strong className="text-[#15201A]">{google.rating}</strong> · {google.review_count} recensioni su Google
              </span>
            ) : (
              <p className="text-sm text-[#5C6B61] mt-1">Leggi le esperienze reali dei pazienti o lascia la tua recensione.</p>
            )}
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center rounded-full bg-[#385244] hover:bg-[#2B4035] text-white text-sm font-bold px-6 py-3 transition-colors duration-300 active:scale-95"
              data-testid="google-reviews-read-btn"
            >
              Leggi le recensioni su Google
            </a>
            <a
              href="https://search.google.com/local/writereview?placeid=ChIJQaQIfmXHhkcRCAi_oM6A2Cs"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center rounded-full border-2 border-[#385244] text-[#385244] hover:bg-[#385244] hover:text-white text-sm font-bold px-6 py-3 transition-colors duration-300 active:scale-95"
              data-testid="google-reviews-write-btn"
            >
              Lascia una recensione
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
